import { render, staticRenderFns } from "./modalEliminarResidentesGrupo.vue?vue&type=template&id=8597a362&scoped=true"
import script from "./modalEliminarResidentesGrupo.vue?vue&type=script&lang=js"
export * from "./modalEliminarResidentesGrupo.vue?vue&type=script&lang=js"
import style0 from "./modalEliminarResidentesGrupo.vue?vue&type=style&index=0&id=8597a362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8597a362",
  null
  
)

export default component.exports